'use client';

import Link from 'next/link';
import classNames from 'classnames';
import { JobDetail } from '~/types/job-detail';

interface ApplicationButtonProps {
  job: JobDetail;
  isMobile: boolean;
  isApplied: boolean;
  isSignedIn: boolean;
  serviceType: 'ad' | 'agent';
  position: 'center' | 'floating';
}

export function ApplicationButton({
  job,
  isMobile,
  isApplied,
  isSignedIn,
  serviceType,
  position,
}: ApplicationButtonProps) {
  // 応募済みの場合
  if (isApplied) {
    return (
      <div
        className={classNames(
          'c-button -lightgray -double u-mr15 -disabled',
          isMobile ? 'u-w150' : '-w280',
        )}
      >
        応募済み
      </div>
    );
  }

  // 自社提案の場合
  if (serviceType === 'agent') {
    return (
      <Link
        href={`/entry_member?job_id=${job.id}&ref=inquiry_${position}_agent`}
        className={classNames(
          'c-button -green -arrow-right u-py10',
          isMobile ? 'u-w150 u-pr8 u-fs12' : 'u-w280',
        )}
      >
        {isMobile ? '求人を問い合わせる' : 'この求人を問い合わせる'}
        <br />
        <p className="u-fs10">（エージェントサービス）</p>
      </Link>
    );
  }

  // 求人広告でログインしていない場合
  return (
    <Link
      href={`/mypage/jobs/new?job_id=${job.id}&ref=application_${position}_ad`}
      className={classNames(
        'c-button -red -double -arrow-right',
        isMobile ? 'u-w150 u-pr8' : '-w280',
      )}
    >
      応募画面へ進む
      {!isSignedIn && position === 'center' && (
        <span className="c-button__micro_copy">1分かんたん応募</span>
      )}
    </Link>
  );
}
